// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: XwuZJuooVSGZ
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import TimeSelect from "../../TimeSelect"; // plasmic-import: E4QEY4senUYo/component
import LastWeekDataButton from "../../LastWeekDataButton"; // plasmic-import: JkxS8x_86SZx/component
import LastMonthDataButton from "../../LastMonthDataButton"; // plasmic-import: adaCFhamF5ax/component
import Last3MonthsDataButton from "../../Last3MonthsDataButton"; // plasmic-import: wjh4FJPBB-SC/component
import LastYearDataButton from "../../LastYearDataButton"; // plasmic-import: D5EWtmzRi5BL/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicTimeSelectStack.module.css"; // plasmic-import: XwuZJuooVSGZ/css
import ChevronUpSvgIcon from "./icons/PlasmicIcon__ChevronUpSvg"; // plasmic-import: NOXSpKy5wnrC/icon
import ChevronDownSvgIcon from "./icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: B3NfmvoQPNM4/icon

createPlasmicElementProxy;

export const PlasmicTimeSelectStack__VariantProps = new Array("postClick");

export const PlasmicTimeSelectStack__ArgProps = new Array();

const $$ = {};

function PlasmicTimeSelectStack__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "postClick",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.postClick
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root,
        { [sty.rootpostClick]: hasVariant($state, "postClick", "postClick") }
      )}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox__oj0QV, {
          [sty.freeBoxpostClick__oj0QVGqbIe]: hasVariant(
            $state,
            "postClick",
            "postClick"
          )
        })}
      >
        <TimeSelect
          data-plasmic-name={"timeSelect"}
          data-plasmic-override={overrides.timeSelect}
          className={classNames("__wab_instance", sty.timeSelect, {
            [sty.timeSelectpostClick]: hasVariant(
              $state,
              "postClick",
              "postClick"
            )
          })}
          currentSelect={
            <div
              data-plasmic-name={"text"}
              data-plasmic-override={overrides.text}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text,
                {
                  [sty.textpostClick]: hasVariant(
                    $state,
                    "postClick",
                    "postClick"
                  )
                }
              )}
            >
              {hasVariant($state, "postClick", "postClick")
                ? "Today"
                : hasVariant(globalVariants, "screen", "medium")
                ? "Yesterday"
                : "Today"}
            </div>
          }
        />

        {(hasVariant($state, "postClick", "postClick") ? true : false) ? (
          <ChevronUpSvgIcon
            data-plasmic-name={"dropdownIcon2"}
            data-plasmic-override={overrides.dropdownIcon2}
            className={classNames(projectcss.all, sty.dropdownIcon2, {
              [sty.dropdownIcon2postClick]: hasVariant(
                $state,
                "postClick",
                "postClick"
              )
            })}
            role={"img"}
          />
        ) : null}
        <ChevronDownSvgIcon
          data-plasmic-name={"dropdownicon"}
          data-plasmic-override={overrides.dropdownicon}
          className={classNames(projectcss.all, sty.dropdownicon, {
            [sty.dropdowniconpostClick]: hasVariant(
              $state,
              "postClick",
              "postClick"
            )
          })}
          role={"img"}
        />
      </div>
      {(hasVariant($state, "postClick", "postClick") ? true : false) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox___53OBk, {
            [sty.freeBoxpostClick___53OBkGqbIe]: hasVariant(
              $state,
              "postClick",
              "postClick"
            )
          })}
        >
          <div className={classNames(projectcss.all, sty.freeBox__v2FzE)}>
            <LastWeekDataButton
              data-plasmic-name={"lastWeek"}
              data-plasmic-override={overrides.lastWeek}
              className={classNames("__wab_instance", sty.lastWeek)}
            />

            <LastMonthDataButton
              data-plasmic-name={"lastMonth"}
              data-plasmic-override={overrides.lastMonth}
              className={classNames("__wab_instance", sty.lastMonth)}
            />

            <Last3MonthsDataButton
              data-plasmic-name={"last3Months"}
              data-plasmic-override={overrides.last3Months}
              className={classNames("__wab_instance", sty.last3Months)}
            />

            <LastYearDataButton
              data-plasmic-name={"lastYear"}
              data-plasmic-override={overrides.lastYear}
              className={classNames("__wab_instance", sty.lastYear)}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "timeSelect",
    "text",
    "dropdownIcon2",
    "dropdownicon",
    "lastWeek",
    "lastMonth",
    "last3Months",
    "lastYear"
  ],

  timeSelect: ["timeSelect", "text"],
  text: ["text"],
  dropdownIcon2: ["dropdownIcon2"],
  dropdownicon: ["dropdownicon"],
  lastWeek: ["lastWeek"],
  lastMonth: ["lastMonth"],
  last3Months: ["last3Months"],
  lastYear: ["lastYear"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTimeSelectStack__ArgProps,
          internalVariantPropNames: PlasmicTimeSelectStack__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTimeSelectStack__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTimeSelectStack";
  } else {
    func.displayName = `PlasmicTimeSelectStack.${nodeName}`;
  }
  return func;
}

export const PlasmicTimeSelectStack = Object.assign(
  // Top-level PlasmicTimeSelectStack renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    timeSelect: makeNodeComponent("timeSelect"),
    text: makeNodeComponent("text"),
    dropdownIcon2: makeNodeComponent("dropdownIcon2"),
    dropdownicon: makeNodeComponent("dropdownicon"),
    lastWeek: makeNodeComponent("lastWeek"),
    lastMonth: makeNodeComponent("lastMonth"),
    last3Months: makeNodeComponent("last3Months"),
    lastYear: makeNodeComponent("lastYear"),
    // Metadata about props expected for PlasmicTimeSelectStack
    internalVariantProps: PlasmicTimeSelectStack__VariantProps,
    internalArgProps: PlasmicTimeSelectStack__ArgProps
  }
);

export default PlasmicTimeSelectStack;
/* prettier-ignore-end */
